export const NOTIFICATION_STATUSES = {
  READ: 1,
  UNREAD: 2,
};

export const NOTIFICATION_TABS = {
  USER: "USER",
  SYSTEM: "SYSTEM",
};